import { useState, useEffect } from 'react';
import { signIn, signUp, confirmSignUp, getCurrentUser, signOut } from '../services/authService';

export const useAuthState = () => {
  const [username, setUsername] = useState(localStorage.getItem('username') || '');
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('username'));
  const [authState, setAuthState] = useState('signIn');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmationCode, setConfirmationCode] = useState('');
  const [authError, setAuthError] = useState('');

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          // Lowercase to match handleSignIn: the login id is stored as typed,
          // and a mixed-case user_id reads/writes different S3 draft keys.
          const loginId = (user.signInDetails?.loginId || user.email || '').toLowerCase();
          setIsAuthenticated(true);
          setUsername(loginId);
          localStorage.setItem('username', loginId);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
      }
    };
    checkAuth();
  }, []);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setAuthError('');
    try {
      await signIn(email, password);
      setIsAuthenticated(true);
      setUsername(email.toLowerCase());
      localStorage.setItem('username', email.toLowerCase());
    } catch (error) {
      setAuthError(error.message);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setAuthError('');
    try {
      await signUp(email, password);
      setAuthState('confirmSignUp');
    } catch (error) {
      setAuthError(error.message);
    }
  };

  const handleConfirmSignUp = async (e) => {
    e.preventDefault();
    setAuthError('');
    try {
      await confirmSignUp(email, confirmationCode);
      setAuthState('signIn');
    } catch (error) {
      setAuthError(error.message);
    }
  };

  const handleLogout = async (onLogoutCallback) => {
    try {
      await signOut();
      localStorage.clear();
      setIsAuthenticated(false);
      setUsername('');
      if (onLogoutCallback) {
        onLogoutCallback();
      }
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return {
    username,
    isAuthenticated,
    authState,
    email,
    password,
    confirmationCode,
    authError,
    setAuthState,
    setEmail,
    setPassword,
    setConfirmationCode,
    handleSignIn,
    handleSignUp,
    handleConfirmSignUp,
    handleLogout
  };
};
